import type { FaireProductEntity } from "../../entity_types/product";

export const p_6fhmd9bt8h: FaireProductEntity = {
  token: "p_6fhmd9bt8h",
  type: "product",
  name: "For Luck's Sake Kitchen Towel",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/e1daa325345e2e5556cd38a2c5e564621d0d201ea813d293c70606d7133402d0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d5099c0706e95c39062036ddc639d2c6b01a9129ad06b2cc7acc90924f683226.jpeg",
    "https://cdn.faire.com/fastly/73ddf7b6368801fad4cc75197becefe2001d02ce1fa155aedd0f7e6abe15ff04.jpeg",
    "https://cdn.faire.com/fastly/456c5348ab88a3a2d2fae0f69fe7b8d52c95f5fef64f6f6bb3bebe062ba10c1f.jpeg",
    "https://cdn.faire.com/fastly/152e79da22af5017b514e71bb115025ae0a48461341c572041a8c23b51d2d380.jpeg",
    "https://cdn.faire.com/fastly/f898b1a96bf85c7bfb121daecef02f752ae772aa37ca1658164a2d8978f80ee1.jpeg",
    "https://cdn.faire.com/fastly/02cc8b6ad64ce2c3727ab9c2e6818702f5cc9f0b7351f110675278a047d20f0d.jpeg"
  ],
  priceDollars: 8,
  description: "A microfiber kitchen towel from our St. Patrick's Day Collection featuring an all-over design displaying a pattern of frogs and clovers with a funny seasonal pun that reads \"For Luck's Sake!\" St. Patrick's Day pattern is replicated from playful hand illustrated artwork. Double-sided towel displays a coordinating green stripe pattern on the back that offers multiple display options with a cotton tape hanger in the corner for hanging. Our For Luck's Sake kitchen towel is conveniently machine washable for easy cleaning. Microfiber towel is packaged on a cardboard hanger with hole to easily display on store rack. A fun St. Patrick's Day kitchen accessory that easily adds seasonal style to any kitchen.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:23.366Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
